<template>
  <sf-modal v-if="showModal" :hide-close="true">
    <template #title>
      {{ I18n.t('accounts.unlocking.modal.title') }}
    </template>

    <template #messages-bottom>
      <sf-modal-message variant="error">
        <p>{{ I18n.t('accounts.unlocking.modal.warning_1') }}</p>
        <p>{{ I18n.t('accounts.unlocking.modal.warning_2') }}</p>
      </sf-modal-message>
    </template>

    <template #footer>
      <button class="sf-btn sf-btn-danger" @click.stop="unlock">
        {{ I18n.t('accounts.unlocking.modal.unlock_accounts') }}
      </button>
      <button class="sf-btn" @click.stop="cancel">
        {{ I18n.t('accounts.unlocking.modal.cancel') }}
      </button>
    </template>
  </sf-modal>
</template>

<script type="text/javascript">
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'
import SFetch from '@app/utils/sfetch'

export default {
  name: 'UnlockAccountNumbersModal',
  components: { SfModal, SfModalMessage },
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    openModal({ url }) {
      this.showModal = true
      this.url = url
    },
    cancel() {
      this.showModal = false
    },
    async unlock() {
      try {
        await SFetch.json(this.url, { method: 'POST' })
        this.showModal = false
        // Reload the page
        window.location = window.location.href
      } catch (error) {
        // Silently fail :(
      }
    },
  },
}
</script>
